<div class="api-doc-container">
  <mat-card class="api-doc-card">
    <mat-card-header>
      <mat-icon mat-card-avatar class="doc-icon">bigtop_updates</mat-icon>
      <mat-card-title>{{ 'dev_area.api_docs_title' | transloco }}</mat-card-title>
      <mat-card-subtitle>{{ 'dev_area.api_docs_subtitle' | transloco }}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      @if (isLoading()) {
        <div class="loading-state">
          <mat-spinner diameter="40"></mat-spinner>
          <p>{{ 'dev_area.api_docs_loading' | transloco }}</p>
        </div>
      } @else if (hasError()) {
        <div class="error-state">
          <mat-icon color="warn">error</mat-icon>
          <p>{{ 'dev_area.api_docs_error' | transloco }}</p>
        </div>
      } @else {
        <p class="description">{{ 'dev_area.api_docs_description' | transloco }}</p>
      }
    </mat-card-content>

    <mat-card-actions class="actions">
      <button mat-flat-button color="primary" (click)="openDocumentation()" [disabled]="isLoading()">
        <mat-icon>open_in_new</mat-icon>
        {{ 'dev_area.api_docs_open_button' | transloco }}
      </button>
      <button mat-button [routerLink]="['/dashboard']">
        <mat-icon>arrow_back</mat-icon>
        {{ 'dev_area.api_docs_back_to_dashboard' | transloco }}
      </button>
    </mat-card-actions>
  </mat-card>
</div>
